import type { GlucoseActivity } from "@tandemdiabetes/sugarmate-api-react-client"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"
import { useDisplayGlucoseString } from "src/hooks"

interface Props extends ComponentPropsWithoutRef<"div"> {
  activity: GlucoseActivity;
}

export const GlucoseActivityTitle = forwardRef<HTMLDivElement, Props>(
  function GlucoseActivityTitle(props: Props, ref: Ref<HTMLDivElement>) {
    const {
      activity,
      ...htmlDivProps
    } = props

    const displayGlucoseString = useDisplayGlucoseString()

    if (!activity.mg_dl) {
      return null
    }


    return (
      <div
        {...htmlDivProps}
        ref={ref}
      >
        {displayGlucoseString(activity.mg_dl)}
      </div>
    )
  },
)
